var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-button",class:`--${_vm.theme}`,style:({
    'height': `${_vm.height}px`,
    'max-width': `${_vm.maxWidth}px`
  }),on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }